import React from "react";
import { Link } from "react-router-dom";
import PublicNavigation from "../components/PublicNavigation";
import PublicFooter from "../components/PublicFooter";
import { usePageMeta } from "../hooks/usePageMeta";
import "./LegalPage.css";

const PrivacyPage: React.FC = () => {
  React.useEffect(() => {
    document.body.classList.add("homepage-route");
    return () => {
      document.body.classList.remove("homepage-route");
    };
  }, []);

  usePageMeta({
    title: "Privacy Policy – CosaVorrei",
    description: "Informativa sulla privacy di CosaVorrei: come trattiamo i tuoi dati personali in conformità al GDPR.",
    canonicalUrl: "https://www.cosavorrei.it/privacy",
    ogUrl: "https://www.cosavorrei.it/privacy",
    ogImage: "https://www.cosavorrei.it/og-image.png",
  });

  return (
    <div className="legal-page">
      <PublicNavigation />
      
      <main className="legal-content">
        <div className="legal-container">
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Ultimo aggiornamento: 8 novembre 2025</p>

          <section className="legal-section">
            <h2>1) Chi siamo</h2>
            <p>
              CosaVorrei è un servizio web per creare gruppi privati e gestire liste di desideri e prenotazioni regalo.
            </p>
            <p><strong>Titolare del trattamento</strong></p>
            <p>
              Luca Mattivi – P.IVA 02600330225<br />
              Sede: Giovo (TN), Italia<br />
              Email: <a href="mailto:info@cosavorrei.it">info@cosavorrei.it</a>
            </p>
            <p>Non è stato nominato un DPO.</p>
          </section>

          <section className="legal-section">
            <h2>2) Quali dati trattiamo</h2>
            <ul>
              <li><strong>Dati account:</strong> nome ed email. Nessuna password viene conservata.</li>
              <li><strong>Dati di utilizzo:</strong> log di accesso, pagine visitate, impostazioni di profilo, gruppo, evento.</li>
              <li><strong>Contenuti inseriti:</strong> nomi di gruppi, eventi, liste, desideri, prenotazioni, commenti o note.</li>
              <li><strong>Cookie tecnici:</strong> cookie essenziali per login e sessione.</li>
              <li><strong>Assistenza:</strong> messaggi inviati via email o form.</li>
            </ul>
            <p>
              Non chiediamo né trattiamo dati "particolari" ai sensi dell'art. 9 GDPR salvo che tu li inserisca volontariamente nei contenuti.
            </p>
          </section>

          <section className="legal-section">
            <h2>3) Perché trattiamo i dati (finalità e basi giuridiche)</h2>
            <ul>
              <li><strong>Erogare il servizio e creare l'account</strong> – esecuzione del contratto art. 6.1.b GDPR.</li>
              <li><strong>Sicurezza e prevenzione abusi</strong> (log tecnici, limitazione tentativi) – legittimo interesse art. 6.1.f.</li>
              <li><strong>Comunicazioni operative</strong> (es. inviti al gruppo, notifiche di prenotazione) – esecuzione del contratto.</li>
              <li><strong>Obblighi di legge</strong> (conservazione log in caso di richieste dell'autorità) – art. 6.1.c.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4) Cookie e tecnologie simili</h2>
            <p>
              Usiamo solo cookie tecnici strettamente necessari per autenticazione e gestione della sessione. 
              Non utilizziamo cookie di profilazione o tracciamento.
            </p>
          </section>

          <section className="legal-section">
            <h2>5) Quanto conserviamo i dati</h2>
            <ul>
              <li><strong>Dati account:</strong> finché mantieni l'account, poi cancellazione entro 30 giorni.</li>
              <li><strong>Log di accesso e sicurezza:</strong> 6–12 mesi.</li>
              <li><strong>Contenuti</strong> (gruppi, eventi, liste): finché resti iscritto o li elimini.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6) Con chi condividiamo i dati</h2>
            <p>Non vendiamo dati. Condividiamo solo con:</p>
            <ul>
              <li>Fornitori che ci aiutano a erogare il servizio (hosting, CDN, email), vincolati da accordi GDPR.</li>
              <li>Autorità se richiesto dalla legge.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7) Trasferimenti extra UE</h2>
            <p>
              Alcuni servizi possono comportare trasferimenti verso Paesi extra SEE. Usiamo Clausole Contrattuali Standard e misure aggiuntive fornite dai vendor.
            </p>
          </section>

          <section className="legal-section">
            <h2>8) Sicurezza</h2>
            <p>
              Applichiamo misure tecniche e organizzative adeguate: cifratura in transito, hashing delle password, controllo accessi, backup. 
              Nessuna misura è perfetta: ti consigliamo password robuste e 2FA quando disponibile.
            </p>
          </section>

          <section className="legal-section">
            <h2>9) I tuoi diritti</h2>
            <p>
              Puoi esercitare i diritti previsti dagli articoli 15–22 GDPR: accesso, rettifica, cancellazione, limitazione, portabilità, opposizione, revoca del consenso. 
              Scrivi a (o <a href="mailto:info@cosavorrei.it">info@cosavorrei.it</a>). 
              Hai anche diritto di reclamo al Garante per la protezione dei dati personali.
            </p>
          </section>

          <section className="legal-section">
            <h2>10) Minori</h2>
            <p>
              Il servizio è destinato ad adulti. Le liste per bambini vengono gestite dagli adulti del gruppo. 
              Se rileviamo account creati direttamente da minori senza consenso dei genitori li rimuoviamo.
            </p>
          </section>

          <section className="legal-section">
            <h2>11) Cambiamenti</h2>
            <p>
              Potremmo aggiornare questa informativa. Le modifiche sostanziali saranno comunicate in-app o via email.
            </p>
            <p>
              <strong>Contatti privacy:</strong> <a href="mailto:info@cosavorrei.it">info@cosavorrei.it</a>
            </p>
          </section>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
};

export default PrivacyPage;
